import React from "react";
import styles from "./empty-dashboard-view.module.scss";
import { ButtonWithIcon } from "@components/atoms/buttons/button-with-icon/button-with-icon";
import plusIcon from "@src/assets/svg/plus-dark-icon.svg";
import { useI18N } from "@src/language/language-context";
import { useDispatch } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";

interface EmptyDashboardViewProps {
  variant: "no-selection" | "empty-dashboard" | "error";
  onAddWidget?: () => void;
}

const cssClassName = "empty-dashboard-view";

export const EmptyDashboardView = ({
  variant,
  onAddWidget,
}: EmptyDashboardViewProps) => {
  const i18n = useI18N();
  const dispatch = useDispatch();

  const texts = {
    noSelection: i18n("pages.dashboardsPage.noSelection"),
    emptyDashboard: i18n("pages.dashboardsPage.emptyDashboard"),
    addFirstWidget: i18n("pages.dashboardsPage.addFirstWidget"),
    addFirstWidgetHint: i18n("pages.dashboardsPage.addFirstWidgetHint"),
    loadError: i18n("pages.dashboardsPage.loadError"),
  };

  const handleAddWidget = () => {
    // Open the widget picker modal (doc §2.2: "Add data widget" → picker modal)
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "widgetPickerModal",
      }),
    );
    onAddWidget?.();
  };

  return (
    <div className={styles[cssClassName]}>
      {variant === "empty-dashboard" ? (
        <div className={styles[`${cssClassName}__card`]}>
          <div className={styles[`${cssClassName}__icon-circle`]}>
            <img src={plusIcon} alt="" />
          </div>
          <div className={styles[`${cssClassName}__text`]}>
            <p className={styles[`${cssClassName}__title`]}>
              {texts.emptyDashboard}
            </p>
            <p className={styles[`${cssClassName}__subtitle`]}>
              {texts.addFirstWidgetHint}
            </p>
          </div>
          <ButtonWithIcon
            fun={handleAddWidget}
            icon={plusIcon}
            text={texts.addFirstWidget}
            variant="primary"
          />
        </div>
      ) : (
        // "no-selection" and "error" share the same centered-paragraph layout;
        // the rendered text differs via the variant lookup below.
        <p className={styles[`${cssClassName}__message`]}>
          {variant === "error" ? texts.loadError : texts.noSelection}
        </p>
      )}
    </div>
  );
};
